import { useMemo } from 'react';

import MailboxService from '../api/MailboxService';
import useMailerDriver from './useMailerDriver';

const useMailboxService = () => {
    const { apiRoutes } = useMailerDriver();

    return useMemo(
        () => MailboxService.getInstance(apiRoutes.API_BASE_URL),
        [apiRoutes.API_BASE_URL]
    );
};

export default useMailboxService;
